module.exports = __webpack_public_path__ + "img/4bacbc1.png";